import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.life;

export const getLifePlansSelector = createSelector(getState, (state) => state.lifePlans);
